export const TEMP_IDD_DOCUMENT_TYPE_ID = '6ede1609-6c97-4d7a-a204-4f794cebbea7';
export const SIGNED_ANSWERS_DOCUMENT_TYPE_ID = 'bdf1ec38-6e7f-4634-8cd2-cbd8032e089e';

export const SIGNED_ANSWERS_DOC = {
  tag: 'idd-signed-answer',
  id: SIGNED_ANSWERS_DOCUMENT_TYPE_ID,
};

